import React from 'react';
import Link from 'gatsby-link';

import Button from '../components/Button';

const handleClick = text => e => {
  e.preventDefault();
  alert(text);
};

const IndexPageCurrent = () => (
  <div>
    <section>
      <p>
        We are a team of <strong>social</strong> and{' '}
        <strong>experienced</strong> software engineers in{' '}
        <strong>Prague</strong>. We work with you as a cross-functional team to
        craft software with amazing tech, customer experience and pragmatism.
      </p>
      <p>
        Our team has many years experience in both developing and managing
        highly scalable and available apps and websites. Experience in working
        with startup as well as enterprise environments. We also love to talk
        tech so feel free to stop by and say &quot;hello&quot;.
      </p>
    </section>
    <section className="right">
      <Button primary href="mailto:roman@shedlabs.tech">
        Say Hello
      </Button>{' '}
      {/* <Button onClick={handleClick('Coming soon...')}>See References</Button> */}
    </section>
  </div>
);

const IndexPage = () => (
  <div>
    <section>
      <p>
        We are a team of <strong>social</strong> and{' '}
        <strong>experienced</strong> software engineers in{' '}
        <strong>Prague</strong>. We work with you as a cross-functional team to
        craft software with amazing tech, customer experience and pragmatism.
      </p>
      <p>
        Our team has many years experience in both developing and managing
        highly scalable and available apps and websites. Experience in working
        with startup as well as enterprise environments. We also love to talk
        tech so feel free to stop by and say &quot;hello&quot;.
      </p>
    </section>

    <section className="flipped">
      <h2>We can help you</h2>
      <ul>
        <li>Validate &amp; realise new ideas</li>
        <li>Deliver quality products &amp; services fast</li>
        <li>Be bold with technology</li>
        <li>Be more customer centric</li>
        <li>Improve efficiency with lean practices</li>
        <li>Deliver &quot;just in time&quot; UX</li>
      </ul>
    </section>

    <section>
      <h2>Our 5 principles</h2>
      <ol>
        <li>
          <strong>People people</strong>
          <br />
          Our work is built on the respect we have for each other and our
          clients. We’re also very focused on the needs of our clients’
          customers.
        </li>
        <li>
          <strong>Find a way</strong>
          <br />
          As individuals we need to be proactive and to earn and build the trust
          of our clients.
        </li>
        <li>
          <strong>Always learning</strong>
          <br />
          We’re curious. It’s how we learn and grow as individuals, continuously
          testing and improving what we do, and how we do it.
        </li>
        <li>
          <strong>Honest</strong>
          <br />
          We’re relied upon to tell things as they are. We do so in an
          approachable and down-to-earth manner.
        </li>
        <li>
          <strong>Strong opinions, weakly held</strong>
          <br />
          Clear points-of-view help give our work direction and purpose – but
          we’re humble about these. We don’t let ego get in the way.
        </li>
      </ol>
    </section>

    <section className="right">
      <Button primary href="mailto:roman@shedlabs.tech">
        Say Hello
      </Button>{' '}
      {/* <Button onClick={handleClick('Coming soon...')}>See References</Button> */}
    </section>

    <section>
      <h2>More about us</h2>
      <div className="flex">
        <div className="box">
          <h3>Experienced.</h3>
          <p>
            Our engineers are experienced. We are polyglots across many
            languages and disciplines. We thrive on the challenging and
            complicated applying our experience across many sectors.
          </p>
        </div>
        <div className="box">
          <h3>Agile.</h3>
          <p>
            We are serious about agile. We have a deep understanding and have
            delivered a plethora of projects using Kanban and SCRUM. We love
            eliminating waste to ship on time and within budget.
          </p>
        </div>
      </div>
      <div className="flex">
        <div className="box">
          <h3>Transparent.</h3>
          <p>
            We work openly and honestly together as one team. Whether it be our
            place or yours. Our pricing model is simple and predictable.
          </p>
        </div>
        <div className="box">
          <h3>Open Source.</h3>
          <p>
            Everyone of us loves open source tech and embraces it. In the end,
            we get a lot of stuff for free, right? :)
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default IndexPageCurrent;



// WEBPACK FOOTER //
// ./src/pages/index.js